import { useContext } from "react";
import { InitDataContext } from "../../context/InitDataContext";
import { puedeVerReportes } from "../../components/reportes/accesoReportes.ts";
import DashboardSolicitudesCompra from "./dashboard.tsx";
import IndexSolicitudesCompraLegacy from "./index_legacy.tsx";

// Users with cost centers in centros_costo_vista get the new reports
// dashboard (cost center 29: everything; otherwise scoped to their cost
// centers by useFiltrosReporte). Users with none keep the legacy screen
export default function IndexSolicitudesCompra() {
  const { initData } = useContext(InitDataContext);
  return puedeVerReportes(initData) ? (
    <DashboardSolicitudesCompra />
  ) : (
    <IndexSolicitudesCompraLegacy />
  );
}
